import { NavLink } from "react-router-dom";
import { cn } from "./ui/cn";
import { useTranslation } from "react-i18next";
import { useHolyMode } from "@/preferences/holy-mode";
import { SacredIcon } from "./sacred-icon";
import { BookOpen, Building2, Tags } from "lucide-react";
import { useHasPermission } from "@/auth/usePermission";

const links = [
  { to: "/", key: "nav.policies", end: true, icon: "book" as const },
  { to: "/domains", key: "nav.domains", end: false, icon: "church" as const },
  { to: "/tag-keys", key: "nav.tagKeys", end: false, icon: "seal" as const, adminOnly: true },
];

const compactIcons = { book: BookOpen, church: Building2, seal: Tags };

export function NavLinks() {
  const { t } = useTranslation();
  const { enabled } = useHolyMode();
  const isAdmin = useHasPermission("BIBLE_ADMIN");
  return (
    <nav className="bible-app-nav flex items-center gap-1" aria-label={t("nav.main")}>
      {links.filter((l) => !l.adminOnly || isAdmin).map((l) => {
        const CompactIcon = compactIcons[l.icon];
        return (
        <NavLink
          key={l.to}
          to={l.to}
          end={l.end}
          className={({ isActive }) =>
            cn(
              "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
              isActive ? "bg-accent-soft text-foreground" : "text-secondary hover:bg-surface-sunken",
            )
          }
        >
          {enabled ? <SacredIcon name={l.icon} size={17} /> : null}
          {!enabled ? <span className="bible-app-nav__compact-icon" aria-hidden="true"><CompactIcon size={17} /></span> : null}
          <span className="bible-app-nav__label">{t(l.key)}</span>
        </NavLink>
        );
      })}
    </nav>
  );
}
